import { Oval } from "react-loader-spinner"
import { Link } from "react-router-dom"

export const StepperButtons = ({ link, isLoading, showNext }) => (
    <div className="flex gap-4 items-center">
        <Link to={link} className="outlined-cta">Back</Link>
        {showNext && (
            <button type="submit" className="btn yellow-cta">
                {isLoading ? <Oval
                    height={30}
                    width={50}
                    color="black"
                    secondaryColor="black"
                /> : (
                    <span>
                        Next
                    </span>
                )}
            </button>
        )}
    </div>
)